import { c as _c } from "react/compiler-runtime";
import { BestSellersSingleBlock } from "./BestSellersSingleBlock";
import { cn } from "@local/utils/src/cn";
import type { Offer } from "@local/offer/src/types";
export const BestSellersMappedBlocks = t0 => {
  const $ = _c(10);
  const {
    isVisible,
    products,
    responsive,
    market
  } = t0;
  let t1;
  if ($[0] !== isVisible || $[1] !== market || $[2] !== products || $[3] !== responsive) {
    t1 = products?.map((product, i) => <div key={`best-sellers-${product.id}`} className={cn(responsive && i === 0 ? "md:hidden" : "")}><BestSellersSingleBlock product={product} index={i + 1} isVisible={isVisible} responsive={responsive} market={market} /></div>);
    $[0] = isVisible;
    $[1] = market;
    $[2] = products;
    $[3] = responsive;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isVisible) {
    t2 = !isVisible && <div className="pointer-events-none absolute inset-0 z-0! bg-gradient-to-b from-transparent from-30% via-transparent to-white md:hidden" />;
    $[5] = isVisible;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="relative grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-9 md:gap-y-3">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};